export default from './BidRequestInfo';



// WEBPACK FOOTER //
// ./src/sharedComponents/BidRequestInfo/index.js